import type { AccountInsulin as ApiAccountInsulin } from "@tandemdiabetes/sugarmate-api-react-client"
import type { AccountInsulin } from "src/types"

export function transformAccountInsulin(accountInsulin: ApiAccountInsulin): AccountInsulin {
  const {
    id,
    insulin_id,
    deleted,
    ...otherProps
  } = accountInsulin

  return {
    ...otherProps,
    id: `${id}`,
    insulin_id: insulin_id === null ? null : `${insulin_id}`,
    is_deleted: !!deleted,
  }
}
